import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaFormFieldComponent } from '../forms/fields/textarea-form-field/textarea-form-field.component';

@Component({
  selector: 'app-ticket-closure-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    TextareaFormFieldComponent
  ],
  templateUrl: './ticket-closure-modal.component.html',
  styleUrl: './ticket-closure-modal.component.scss'
})
export class TicketClosureModalComponent {
  @Input() title!: string;
  @Input() confirmActionLabel!: string;
  @Input() notConfirmActionLabel!: string;

  form!: FormGroup;

  constructor(
    public modalService: NgbActiveModal,
    private fb: FormBuilder, 
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      resolution: [null, Validators.required],
    });
  }

  confirm(action: boolean) {
    const result = {
      action: action,
      value: this.form.getRawValue()
    }

    this.modalService.close(result);
    this.resetForm();
  }

  close() {
    this.modalService.dismiss();
    this.resetForm();
  }

  resetForm() {
    setTimeout(() => {
      this.form?.reset();
    }, 300);
  }

}
